const SlackDetailPage = () => {
    return (
        <div>
            Chat is unstructured communication and so only supports product development that is mostly disjoint tasks.
            
            There are tools that attempt to find and import to do lists from Slack, but they will not give you much
            visualization or backlog management.
            <br /><br />
            Furthermore chat being unstructured increases the pressure for a developer to answer immediately. In 
            structured communication it is easier to return later and understand the context.
        </div>
    );
};
export default SlackDetailPage;